import React, { useEffect, useState } from "react"

import {
  Form,
  RadioButtonGroup,
  CheckboxInput,
} from "./Form"

import 'react-credit-cards/lib/styles'

import DeliveryDetails from "./DeliveryDetails";
import InvoiceEmail from "./InvoiceEmail";
import GuestOverrideName from "./GuestOverrideName";
import CreditCardPaymentForm from "./CreditCardPaymentForm";
import { validateCreditCardDetails } from '../utils/creditcard'
import FullScreenLoader from "./FullScreenLoader";
import { fetchOrderResponse, showOrderOutcome } from "../withOrder";
import { checkoutErrorSteps } from "../../orders/orderResponse";
import { sendsCardBrandGuess } from "../../orders/cardBrandGuess";
import { showsPanel } from "../../eftpos/panelView";

// WDCE-199 step 9g-4b: FoodTableOrder passes locked (true or false) while the EFTPOS panel is on. The order table and
// the customer's fields then sit in one fieldset, disabled while locked. It's there for as long as the prop is, so
// locking and unlocking never remount the fields (they keep what was typed). Without the prop, there's no fieldset.
const LockableFields = ({ locked, children }) => (
  typeof locked === 'boolean' ? <fieldset disabled={locked}>{children}</fieldset> : <>{children}</>
)

export default props => {
  const [paymentType, setPaymentType] = useState(Object.keys(props.order.paymentTypes)[0])
  const [submittingOrder, setSubmittingOrder] = useState(false)
  const [validCreditCard, setValidCreditCard] = useState(false)
  const [displayValidationErrors, setDisplayValidationErrors] = useState(false)
  const [displayAddress, setDisplayAddress] = useState((parseInt(props.selfPickUp)))
  const [creditCardNumber, setCreditCardNumber] = useState("")
  const [displayInvoiceEmail, setInvoiceEmail] = useState(props.order.orderType == 'pos')
  const [deliveryRequired, setDeliveryRequired] = useState(props.order.orderType != 'pos')
  const [processAndPrintRequested, setProcessAndPrintRequested] = useState(false)
  // WDCE-199 step 9g-3b: FoodTableOrder keeps the process-and-print checkbox's state (processAndPrint), so the EFTPOS
  // panel can send it, and may give an EFTPOS panel to show in place of the card form and the main button. Other
  // screens give neither, and keep this form's own checkbox state.
  const processAndPrintChecked = props.processAndPrint ? props.processAndPrint.checked : processAndPrintRequested
  const setProcessAndPrintChecked = props.processAndPrint ? props.processAndPrint.onChange : setProcessAndPrintRequested
  const showEftposPanel = showsPanel({ hasPanel: Boolean(props.eftposPanel), paymentType, active: props.eftposActive })
  // WDCE-199 step 9g-4b: the payment types the descriptions and radios offer (FoodTableOrder: only EFTPOS once part is
  // paid). Other screens give none, and offer the order's.
  const offeredPaymentTypes = props.offeredPaymentTypes || props.order.paymentTypes

  useEffect(() => {
    $(document).on("keydown", ":input:not(textarea)", function (event) {
      return event.key != "Enter";
    })
  }, [])

  const saveCreditCardPrefix = (creditCardNumber) => {
    const cleanedNumber = creditCardNumber.replace(/[\s-]/g, '');
    let paymentMethod = "OT"

    if (/^4[0-9]{12}(?:[0-9]{3})?$/.test(cleanedNumber)) {
      // Visa (VI)
      paymentMethod = "VI";
    } else if (/^5[1-5][0-9]{14}$/.test(cleanedNumber) || /^2(2[2-9][1-9]|[3-6][0-9]{2}|7[0-1][0-9]|720)[0-9]{12}$/.test(cleanedNumber)) {
      // MasterCard (MC)
      paymentMethod = "MC";
    } else if (/^3[47][0-9]{13}$/.test(cleanedNumber)) {
      // American Express (AE)
      paymentMethod = "AE";
    } else {
      // Other (OT)
      paymentMethod = "OT"
    }
    // WDCE-199 step 9e: resolves with the outcome (orders/orderResponse.js), after showing anything but ok.
    return fetchOrderResponse(`/orders/${props.order.id}.json`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").getAttribute("content"),
      },
      body: JSON.stringify({ order: { payment_method: paymentMethod } })
    })
    .then(outcome => {
      showOrderOutcome(outcome)
      return outcome;
    })
  };

  const actionButtonTitle = () => {
    return Object.entries(props.order.paymentTypes).find(([key, value]) => key == paymentType)[1].shortName
  }

  const submitOrder = async e => {
    e.preventDefault()
    setDisplayValidationErrors(true)
    setSubmittingOrder(true)
    // WDCE-199 step 9e: on a POS order, only for credit card (orders/cardBrandGuess.js). If it can't be saved, the
    // outcome has been shown, and the checkout isn't sent.
    if (sendsCardBrandGuess(props.order.orderType, paymentType)) {
      const saved = await saveCreditCardPrefix(creditCardNumber)
      if (saved.kind !== 'ok') {
        setSubmittingOrder(false);
        return;
      }
    }

    props.handleOrderUpdate({ checkout: true, paymentType: paymentType }).then(outcome => {
      // withOrder has shown anything but ok, and reloads or leaves the page if the outcome says to.
      if (outcome.kind !== 'ok') {
        setSubmittingOrder(false);
        return;
      }

      if (paymentType == 'credit_card' && !validCreditCard) {
        alert(`Please check your credit card information and try again.`)

        setSubmittingOrder(false);
        return;
      }

      const errorSteps = checkoutErrorSteps(outcome.order.errors)
      if (errorSteps.length > 0) {
        errorSteps.forEach(step => step.reload ? window.location.reload() : alert(step.alert))
        setSubmittingOrder(false);
        return;
      }

      if (paymentType == 'credit_card') {
        document.getElementById('payment-form').submit();
      } else if (['invoice', 'cash'].includes(paymentType)) {
        window.location.reload();
      } else {
        window.open(`${props.orderPath}.pdf`, '_blank');
      }
    })
  }
  useEffect(() => {
    setDisplayAddress(parseInt(props.selfPickUp))
  }, [props.selfPickUp])


  return (
    <div className="edit_order">
      {submittingOrder && <FullScreenLoader />}
      <Form className="simple-form" id="order-form">

        <LockableFields locked={props.locked}>
          {props.children}

          <hr />

          {!([1, 2].includes(displayAddress)) && (
            <DeliveryDetails
              order={props.order}
              countries={props.countries}
              handleOrderUpdate={props.handleOrderUpdate}
              onDeliveryRequiredChange={props.onDeliveryRequiredChange}
            />
          )}

          {displayInvoiceEmail && (
            <InvoiceEmail
              order={props.order}
            />
          )}

          {props.order.orderType == 'pos' && props.order.foodTableGuestOrder && (
            <GuestOverrideName
              order={props.order}
            />
          )}
        </LockableFields>

        {props.order.orderType == 'pos' && (
          <CheckboxInput
            label=" Process order and print packing slip on payment"
            name="order[process_and_print_requested]"
            wrapperHTMLClassName="col-sm-12"
            checked={processAndPrintChecked}
            onChange={(e) => setProcessAndPrintChecked(e.target.checked)}
          />
        )}
      </Form>

      <h2 className="text-center">Payment</h2>
      <div className="payment">
        <div className="text-container">
          <p><strong>Payment Options:</strong></p>
          {Object.entries(offeredPaymentTypes).map(([key, value]) => <p key={key}>
            {value.description}
          </p>)}
        </div>

        <RadioButtonGroup
          name="payment_type"
          options={Object.entries(offeredPaymentTypes).map(([key, value]) => [value.longName, key])}
          wrapperHTMLClassName="order_payment_type"
          onChange={(e) => setPaymentType(e.target.value)}
          defaultChecked={paymentType}
        />
      </div>

      {paymentType == "credit_card" && !showEftposPanel &&
        <CreditCardPaymentForm
          paymentGatewayData={props.order.paymentGatewayData}
          handleValidationChange={(valid) => setValidCreditCard(valid)}
          displayValidationErrors={displayValidationErrors}
          totalAmount={props.totalAmount}
          number={creditCardNumber}
          setNumber={setCreditCardNumber}
        />
      }

      {showEftposPanel && props.eftposPanel}

      {!showEftposPanel && <div className="form-actions">
        <button
          className="btn btn-primary btn-lg text-uppercase"
          name="commit"
          onClick={submitOrder}
          disabled={submittingOrder}
        >
          {submittingOrder ? 'Processing...' : actionButtonTitle()}
        </button>
      </div>}
    </div>
  )
}
